import { render, staticRenderFns } from "./select-soc.vue?vue&type=template&id=539e4f90&"
import script from "./select-soc.vue?vue&type=script&lang=js&"
export * from "./select-soc.vue?vue&type=script&lang=js&"
import style0 from "./select-soc.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports